module.exports = __webpack_public_path__ + "static/media/icon_g.dfc6d1ba.svg";